import qs from 'qs'
import bridgeMixin from './bridge'
import {
  // goApp,
  versionfunegt,
  updateOrDownLoadApp,
  GetQueryString
} from '../libs/utils'
import Bridge from 'src/frontend-lib/lib/Bridge'
import consultNotice from '../components/consultation/consultNotice.vue'
import sdkDialog from 'src/components/consultation/sdkConsultDialog'
import consultLinkMixin from 'src/mixins/consult/link'

const consultOrder = {
  mixins: [bridgeMixin, consultLinkMixin],
  components: {
    // 多地方需要用，所以在这里引入
    consultNotice,
    sdkDialog
  },

  data() {
    return {
      showUpdateAppTips: false,
      sdkRoomToken: '',
      sdkConsultDialogConfig: {
        show: false,
        sdkConsultDialogCancel: () => {},
        sdkConsultDialogProcess: () => {}
      },

      userAccid: '',
      callId: ''
    }
  },
  computed: {
    useApp() {
      // const { name } = this.$route
      // 是否调用协议，客户端大佬还没拍板说要不要占用他们时间改协议，搞个变量吧。
      return this.mixinIsApp
    },
    staticSite() {
      // static站url
      return location.protocol + '//' + location.host + location.pathname
    },
    canMadeCall() {
      const { _version } = this.$route.query
      // 如果是app而且版本大于sdk版本
      return this.mixinIsApp && versionfunegt(_version, '5.2.1')
    },
    // showUpdateAppTips() {
    //   return !this.canMadeCall
    // }
    /**
     * 能否支持发起云信SDK通话，版本号为5.9.1
     * @returns {bridgeMixin.computed.mixinIsApp|boolean}
     */
    canMadeSDKCallv2() {
      const { _version } = this.$route.query
      //this.platform.isPc  暂时不开发pc端
      return this.mixinIsApp && versionfunegt(_version, '5.9.1')
    },

    CANNOT_CHANGE_PRICE_TIPS() {
      return `该订单为平台承担优惠，不允许修改价格`
    }
  },
  created() {
    // this.checkoutAppUpgrade()
  },
  methods: {
    /**
     * 调用客户端的加入七牛云房间的方法
     * @private
     */
    _sdkConsultFlow({
      consultId,
      callType,
      // orderId,
      // isAdmin, //是否是管理员：0：不是，1：是。默认为 0
      // userId, //自己的昵称（生成 roomToken 用的 userId）
      // 新增callAction参数
      mineName,
      //todo:检查一下remoteNames应该可以删除
      // remoteNames, // 其他用户组成的userId: userName组成的map
      remoteName, // 对面用户的名称
      remoteAvatarUrl, // 对面用户的头像url
      mineAvatarUrl,
      // role

      remoteRealName, // 远端用户的真实姓名
      localRealName // 本地用户的真实姓名
    }) {
      console.log('option11111111', {
        consultId,
        callType,
        mineName,
        remoteName, // 对面用户的名称
        remoteAvatarUrl, // 对面用户的头像url
        mineAvatarUrl
      })
      console.log('canMadeSDKCallv2', this.canMadeSDKCallv2)
      if (!this.canMadeSDKCallv2) {
        // 版本太旧，提示升级
        console.log('版本太旧？')
        this.$dialog({
          maskClose: true,
          title: this.mixinIsApp
            ? '请升级到最新的APP，使用该功能。'
            : '语音和视频沟通只支持在APP上进行,请下APP后操作',
          theme: '#459cf3',
          buttons: [
            {
              label: '更新安装APP'
            }
          ]
        }).then(updateOrDownLoadApp)
      } else {
        console.log('开始咨询流程')
        this._checkPhoneSetting() // 检查app音视频权限
          .then(this._showSDKConsultNotice)
          // 显示咨询须知弹窗
          .then(() => this._getReadyCall(consultId))
          .then(res => {
            if (this.mixinIsApp) {
              this.getBridge().call('loginNim', {
                account: res.data.accid,
                token: res.data.cloud_token
              })
            }

            if (this.platform.isPc) {
              // window.location.href = `${
              //   this.pcSite
              // }yuyue/consult-room/${consultId}`
            } else {
              const sdkConfig = {
                callType,
                callId: this.callId,
                account: this.userAccid,
                localAvatar: mineAvatarUrl,
                localDisplayName: mineName,
                remoteDisplayName: remoteName,
                remoteAvatar: remoteAvatarUrl
              }
              const { _version } = this.$route.query
              if (versionfunegt(_version, '6.3.2')) {
                sdkConfig.remoteRealName = remoteRealName
                  ? `(${remoteRealName})`
                  : ''
                sdkConfig.localRealName = localRealName
                  ? `(${localRealName})`
                  : ''
              }
              console.log(
                `versionfunegt(_version, '6.3.2')`,
                versionfunegt(_version, '6.3.2')
              )
              console.log(`sdkConfig`, sdkConfig)
              this.madeCall(sdkConfig)
            }
          })
          .catch((error = {}) => {
            if (!this.platform.isPc) {
              let myBridge = new Bridge()
              if (error.code === '-2') {
                // 处理没权限的情况，打开App内置的权限引导弹窗
                myBridge.call('showVoiceAndVideoPermissionDialog')
              } else {
                console.error(error)
              }
            }
          })
      }
    },
    /**
     * 检查有没有未完成的咨询
     * @param consultStatus
     * @returns {Promise<any>}
     * @private
     */
    _getReadyCall(consultId) {
      let tokenPromise = this.getSDKCallId(consultId)
      return tokenPromise.then(res => {
        if (+res.code === 40007) {
          this.$dialog({
            title: `上次咨询还没有完成\n请先完成上次咨询`,
            theme: '#0B8BFF',
            buttons: [{ label: '我知道了' }]
          })
          throw 0
        } else if (+res.code === 0) {
          return res
        }
      })
    },
    /**
     * 检查是够有手机权限，异常情况抛出去给外面处理
     * @returns {Promise<any>}
     * @private
     */
    _checkPhoneSetting() {
      return new Promise((resolve, reject) => {
        //PC 跳过检查权限
        if (this.platform.isPc) {
          resolve(1)
          return
        }

        let myBridge = new Bridge({
          methods: [
            {
              method: 'checkVoiceAndVideoPermission',
              callback: function({ hasPermission }) {
                console.log(hasPermission)
                // 客户端返回{hasPermission: true}，直接取 hasPermission
                if (hasPermission) {
                  console.log('APP有权限')
                  resolve(1)
                } else {
                  // 显示请求权限的弹窗
                  reject({
                    code: '-2',
                    msg: '没有手机语音/摄像头权限'
                  })
                }
              }
            }
          ]
        })
        myBridge.call('checkVoiceAndVideoPermission', {
          callbackName: 'checkVoiceAndVideoPermission'
        })
        console.log('检查权限', window.checkVoiceAndVideoPermission, myBridge)
      })
    },
    /**
     * 显示咨询须知弹窗
     * @private
     */
    _showSDKConsultNotice() {
      return new Promise((resolve, reject) => {
        let a = Object.assign({}, this.sdkConsultDialogConfig)
        console.log('出现sdk弹窗1', a)
        this.sdkConsultDialogConfig.show = true
        // this.$set(this.sdkConsultDialogConfig, 'show', true)
        console.log('出现sdk弹窗2', this.sdkConsultDialogConfig)

        this.sdkConsultDialogConfig.sdkConsultDialogCancel = () => {
          this.sdkConsultDialogConfig.show = false
          console.log('取消')
          reject()
        }
        this.sdkConsultDialogConfig.sdkConsultDialogProcess = () => {
          this.sdkConsultDialogConfig.show = false
          console.log('发起通话')
          resolve()
        }
      })
    },
    /**
     * 获取在线咨询室token
     * @param consultId 咨询详情id
     * @private
     */
    getSDKCallId(consultId) {
      return this.$http
        .get(`${this.mobileSite}consult/make-cloud-call`, {
          params: {
            consult_id: consultId
          }
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.userAccid = res.data.user_accid
            this.callId = res.data.call_id
          } else {
            this.$dialog({
              title: `订单信息错误`,
              theme: '#0B8BFF',
              buttons: [{ label: '确定' }]
            })
          }
          return res
        })
    },
    /**
     * 获取当前在线咨询室的用户
     * @param consultId 咨询详情ID
     * @private
     */
    _getSDKRoomJoinedUser(consultId) {
      return this.$http
        .get(`${this.mobileSite}yuyue/get-room-user`, {
          params: {
            id: consultId
          }
        })
        .then(({ data: res }) => {
          if (+res.code === 0) {
            // good
            return res.data
          } else if (+res.code === 1) {
            // 仅当前订单用户或咨询师可以查看
            window.toast('仅当前订单用户或咨询师可以查看')
            return []
          } else if (+res.code === 20002) {
            // 咨询记录不存在
            window.toast('咨询记录不存在')
            return []
          }
        })
        .catch(error => {
          console.error(error)
        })
    },
    /**
     * 调用客户端的加入七牛云房间的方法
     * @param config
     * config.roomToken 七牛房间标识
     * config.callType 呼叫类型：0：音频，1：视频。默认为音频
     * config.orderId 订单号
     * config.isAdmin 是否是管理员：0：不是，1：是。默认为 0
     * config.userId 自己的昵称（生成 roomToken 用的 userId）
     * @private
     */
    madeCall(config) {
      let myBridge = new Bridge()
      // console.log('callAction', config)
      myBridge.call('startAudioVideoCall', config)
    },
    /**
     * App内打开设置界面，用户手动设置
     * @private
     */
    _goSetPhonePermission() {
      if (this.platform.isYixinliApp || this.platform.isZiXunApp) {
        let myBridge = new Bridge()
        console.log('去设置手机麦克风/摄像头权限')
        myBridge.call('gotoSystemPermissionSetting')
      } else {
        this.$dialog({
          theme: '#0B8BFF',
          title: 'M站暂不支持直接打开系统设置，请在壹心理App内操作',
          buttons: [{ label: '好的' }]
        })
      }
    },
    /**
     *
     * @param consultId
     * @returns {AxiosPromise}
     */
    getPrivitePhoneNumber(consultId, mobileNum) {
      return this.$http.get(
        `//m${
          this.runningEnv.env !== '' ? '-' + this.runningEnv.env : ''
        }.xinli001.com/yuyue/bind-secret-phone`,
        {
          params: {
            id: consultId,
            phone: mobileNum
          }
        }
      )
    },
    /**
     * 检查网络状态
     */
    checkoutNetWorkStatus() {
      this.getBridge().call('checkoutNetWorkStatus', {
        callbackName: 'jsCheckoutNetWorkStatus'
      })
      new Bridge({
        methods: [
          {
            method: 'jsCheckoutNetWorkStatus',
            callback: obj => {
              console.log('checkoutNetWorkStatus', obj)
            }
          }
        ]
      })
    },
    /**
     * App升级方法
     */
    checkoutAppUpgrade() {
      //咨询APP不显示更新提示
      if (this.platform.isZiXunApp) return

      if (!this.canMadeCall && !this.platform.isZiXunApp) {
        this.showUpdateAppTips = true
      }
      if (this.mixinIsApp) {
        this.getBridge().call('checkUpgrade', {
          callbackName: 'jsGetCheckUpgrade'
        })

        new Bridge({
          methods: [
            {
              method: 'jsGetCheckUpgrade',
              callback: obj => {
                console.log(obj)
                // ios调整前返回content
                const upKey = obj.isUpgrade
                console.log(upKey)

                // 安卓最新版5.3.6调用此方法依然返回1，因此兼容处理
                if (
                  this.platform.isAndroid &&
                  upKey &&
                  GetQueryString('_version', window.location.hash) === '5.3.6'
                ) {
                  this.showUpdateAppTips = false
                } else {
                  this.showUpdateAppTips = upKey === 0 ? false : true
                }
              }
            }
          ]
        })
      } else {
        this.showUpdateAppTips = true
      }
    },
    /**
     * 预约详情进度条
     * @param {Boolean} isUser 是否是用户
     * @param {Number} process 第几个进度， 接口返回的
     */
    /*   getProgressBarData(isUser, process) {
      const orderState = {
        beforeAccept: [
          '待支付',
          '待接受',
          '待咨询',
          '待确认',
          '待评价' //todo:如果已评价就是已完成
        ],
        afterAccept: ['已支付', '已接受', '已咨询', '已确认', '已评价'], //todo:已完成
        cancel: ['未支付', '已取消'], // todo:已支付
        refund: [
          ...['已支付', '未接受', '退款中', '已退款']
          // ...(isUser ? ['退款'] : [])
        ]
      }
      return orderState[process]
    },*/

    /**
     * 获得咨询列表数据
     * @param {String} id 订单id
     * @param {Number} page 第几页
     * @param {Number} recordStatus 是否是已完成 wait、complete、cancel
     */
    getRecordList(id, page, recordStatus) {
      let url = `${this.mobileSite}yuyue/recordList?id=${id}&page=${page}`
      url = recordStatus ? url + `&record_status=${recordStatus}` : url
      return this.$http
        .get(url)
        .then(res => {
          const resData = res.data
          if (resData.code === 0) {
            return resData.data
          } else {
            monitor.stat({
              level: 'error',
              error: 'api',
              url,
              msg: `code ===${resData.code}`
            })
          }
        })
        .catch(e => {
          monitor.stat({
            level: 'error',
            error: 'api',
            url,
            msg: e
          })
        })
    },

    /**
     * 预约其他咨询师
     */
    linkToTeacherList() {
      if (this.platform.isYixinliApp) {
        // 只有壹心理app跳协议
        window.location.href = 'yixinli://open_teacher_list'
      } else {
        this.openWebView({
          url: this.staticSite + '#/consult-expert-list'
        })
      }
    },

    /**
     * 去搜索页面
     */
    linkToSearch() {
      // this.openWebView({
      //   url: this.staticSite + '#/consult-search'
      // })
      setTimeout(() => {
        document.querySelector('.search-bar-input input').focus()
      }, 1000)
      this.$router.push('consult-search')
    },

    /**
     * 去支付
     * @param {String} orderId
     */
    linkToPay(orderId) {
      if (this.platform.isPc) {
        // PC端订单详情跳PC支付
        const env =
          location.host.split('.')[0].split('-')[1] === undefined
            ? ''
            : location.host.split('.')[0].split('-')[1]

        window.location.href = `${location.protocol}//www${
          env ? '-' + env : ''
        }.xinli001.com/user/yuyue/pay-${orderId}`
      } else {
        const url = `${this.mixinIsApp ? 'https://' : ''}${
          this.mobileSite
        }zhifu/pay-${orderId}`
        this.openWebView({ url: url, isCurrentPageOpen: 0 })
        // window.location.href = url
      }
    },

    /**
     * 去评价
     * @param {String} orderId 订单id
     */
    linkToComment(orderId) {
      this.openWebView({
        url: this.staticSite + '#/resv-comment?id=' + orderId
      })
      // this.$router.push({
      //   path: 'resv-comment',
      //   query: {
      //     id: orderId
      //   }
      // })
    },

    /**
     * 去详情
     * @param {Boolean}} isUser 是否是用户
     * @param {String} orderId 订单id
     */
    linkToDetail(isUser, orderId) {
      this.openWebView({
        url:
          this.staticSite +
          '#/resv-order-detail-' +
          (isUser ? 'user' : 'teacher') +
          '?id=' +
          orderId
      })
      // this.$router.push({
      // 	path: 'resv-order-detail-' + (isUser ? 'user' : 'teacher'),
      // 	query: {
      //     id: orderId
      // 	}
      // })
    },

    /**
     * 再次预约
     * @param {String} teacherId 老师id
     * @param {String} orderId 订单id

     * @param isExpired    1：咨询师已下架  0： 正常
     * @param isAvailable  1：可预约   0： 暂停预约
     */
    async linkToReservation(teacherId, orderId, isExpired, isAvailable) {
      if (isExpired || !isAvailable) {
        if (isExpired) {
          window.toast('该咨询师已下架', 1500)
        } else {
          window.toast('该咨询师已暂停预约', 1500)
        }
        await setTimeout(() => {}, 1500)
        const url = `${
          this.staticSite
        }#/consult-expert-list?from=consult-order-page`
        this.openWebView({ url: url, isCurrentPageOpen: 0 })
      } else {
        this.openWebView({
          url: this.staticSite + `#/consult-order-page?to_user_id=` + teacherId,
          isCurrentPageOpen: 0,
          hideNavigationBar: 1
        })
      }

      //
    },
    /**
     * 查看订单历史
     * @param {String} userId 用户或咨询师id
     */
    linkToOrderHistory(userId) {
      this.openWebView({
        url: this.staticSite + '#/resv-order-history?userId=' + userId
      })
    },

    /**
     * 跳转用户主页
     * @param userId
     */
    linkToUserPage(userId) {
      this.mixinToTeacherPage(userId)
    },

    /**
     * 打开私信界面
     * @param id  用户id
     */
    // handleSendLetter({ id, myOrder}) {
    //   console.log('id---', id,myOrder)
    //   if (this.mixinIsApp) {
    //     window.location.href = `yixinli://open_chat?user_id=${id}`
    //   } else {
    //     this.isShowLetterDialog = true
    //     // this.$emit('setCurOrderInfo', myOrder)
    //     this.setCurOrderInfo(myOrder)
    //   }
    // },

    _action(isUser, params) {
      // 很多地方用到action接口，所以简单抽离
      const reqUrl =
        this.mobileSite + (isUser ? 'yuyue/useraction' : 'yuyue/teacheraction')
      const loading = this.$loading()
      let ajax
      if (isUser) {
        ajax = this.$http(reqUrl, { params, disabledUnLoginInterceptors: true }) // 频繁操作会返回40002，中了拦截器了
      } else {
        ajax = this.$http.post(reqUrl, qs.stringify(params), {
          disabledUnLoginInterceptors: true
        }) // 频繁操作会返回40002，中了拦截器了
      }
      return ajax
        .then(res => {
          loading.close()
          return res
        })
        .catch(e => {
          loading.close()
          console.log(e)
          monitor.stat({
            level: 'error',
            error: 'api',
            url: reqUrl,
            msg: e
          })
        })
    },

    /**
     * 用户-待支付-取消订单 (咨询师取消订单需要填理由，跳转到 resv-cancel-reason，方法在页面组件内)
     * @param {String} orderId
     */
    cancelOrder(orderId, callback) {
      return new Promise(resolve => {
        this.$dialog({
          title: '是否取消订单？',
          theme: '#0B8BFF',
          buttons: [{ label: '再考虑一下' }, { label: '取消订单' }]
        })
          .then(() => {
            return this._action(true, {
              id: orderId,
              action: 'cancel'
            })
          })
          .then(res => {
            if (res.data.code == 0) {
              this.$success('订单已取消', async () => {
                try {
                  if (this.mixinIsApp) {
                    this.noticeConsultationPageReLoad()
                  } else {
                    typeof callback === 'function' && (await callback())
                  }
                  resolve()
                } catch (e) {
                  console.log(e)
                }

                // window.location.href = this.mixinIsApp ? 'yixinli://open_my_appoint_list' : (this.mobileSite + 'user/yuyue')
                // window.location.href = this.mobileSite + 'user/yuyue'
                // window.location.href = this.staticSite + '#/consult-list-user'
              })
            } else {
              this.$fail('操作失败')
              throw new Error('用户待付款取消订单失败' + res.data.code)
            }
          })
      })

      // }
    },

    /**
     * 提醒确认
     * @param {Boolean} isUser 是否是用户
     * @param {String} orderId 订单id
     */
    async remind(isUser, orderId) {
      // if (this.useApp) {
      //   window.location.href = `yixinli://change_${isUser ? 'user' : 'teacher'}_appoint_status?id=${orderId}&status=remind`
      // } else {
      console.log('isUser', isUser)
      const reqUrl =
        this.mobileSite + (isUser ? 'yuyue/userremind' : 'yuyue/teacherremind')
      const loading = this.$loading()
      try {
        const res = await this.$http.get(reqUrl, {
          params: {
            id: orderId
          },
          disabledUnLoginInterceptors: true // 避开拦截器，见main.js
        })
        loading.close()
        const { code, message } = res.data
        if (code == 0 || code == 40002) {
          this.$success('提醒成功')
        } else {
          this.$fail(message || '提醒失败')
          throw new Error('提醒确认失败' + code)
        }
      } catch (e) {
        loading.close()
      }
      // }
    },

    /**
     * 接受预约
     * @param {String} orderId 订单id
     * @param {Number} phone 电话号码 - 调协议用的 never used
     */
    acceptReservation(order, callback) {
      // 兼容传入orderid
      const orderId = typeof order === 'object' ? order.id : order
      const isUncomplete = typeof order === 'object' ? order.is_uncomplete : ''
      const toChatId = typeof order === 'object' ? order.user_id : ''

      return new Promise(resolve => {
        const success = async () => {
          try {
            this.noticeConsultationPageReLoad({
              currentUrl: window.location.href // 不刷新本页面
            })
            // if (this.mixinIsApp) {
            // } else {
            typeof callback === 'function' && (await callback())
            // }
            resolve()
          } catch (e) {
            console.log(e)
          }
        }
        return this._action(false, {
          id: orderId,
          action: 'accept'
        }).then(res => {
          if (res.data.code == 0) {
            if (isUncomplete) {
              this.$dialog({
                theme: '#0B8BFF',
                buttons: [{ label: '取消' }, { label: '私信提醒' }],
                title:
                  '受理成功，来访者没有补充预约信息，请私信提醒来访者及时补充，以保证咨询顺利进行。'
              })
                .then(() => {
                  success()
                  this.toChat(toChatId)
                })
                .catch(() => {
                  success()
                })
            } else {
              this.$success('待协商后进行咨询', () => success(), 1000)
            }
          } else {
            this.$fail('操作失败')
            throw new Error('接受预约失败' + res.data.code)
          }
        })
      })
    },

    /**
     * 拒绝协商时间
     * @param id   咨询详情id
     * @param fn
     */
    rejectTime(id, fn) {
      return this.$http
        .get(`${this.mobileSite}yuyue/confirm-appoint-time`, {
          params: {
            consult_id: id
          }
        })
        .then(res => {
          const { message, code } = res.data
          if (code === 0) {
            typeof fn === 'function' && fn()
          }
          window.toast(message)
        })
        .catch(e => {
          console.log(e)
        })
    },

    /**
     * 拒绝预约
     * @param {String} orderId 订单id
     */
    refuseReservation(orderId) {
      this.openWebView({
        url: `${this.staticSite}#/resv-reject-reason?id=${orderId}`
      })
      // return new Promise(resolve => {
      //   if (this.useApp) {
      //     window.location.href = 'yixinli://change_teacher_appoint_status?id=' + orderId + '&status=denied'
      //     // resolve()
      //   } else {
      // return this._action(false, {
      //   id: orderId,
      //   action: 'refuse',
      //   reason: '专家忙碌中，无法接受预约。'
      // })
      //   .then(res => {
      //     if(res.data.code == 0) {
      //       this.$success('预约失效')
      //       this.noticeConsultationPageReLoad()
      //       return Promise.resolve()
      //     } else {
      //       this.$fail('拒绝失效')
      //       throw new Error('拒绝订单失败' + res.data.code)
      //     }
      //   })
      // }
      // })
    },

    /**
     * 确认完成
     * @param {Boolean} isUser 是否是用户
     * @param {String} orderId 订单id
     */
    confirmOrder(isUser, orderId, callback) {
      const context = isUser
        ? '请确认咨询是否已完成？'
        : '在你确认完成后，平台将发送短信提醒来访者确认完成。'
      return this.$dialog({
        theme: '#0B8BFF',
        title: context,
        buttons: [{ label: '取消' }, { label: '确认完成' }]
      })
        .then(() => {
          return this._action(isUser, {
            id: orderId,
            action: 'confirm'
          })
        })
        .then(async res => {
          const { code, message } = res.data
          if (code == 0) {
            try {
              this.$success(message)
              if (this.mixinIsApp) {
                this.noticeConsultationPageReLoad()
              } else {
                typeof callback === 'function' && (await callback())
              }
              return Promise.resolve()
            } catch (e) {
              console.log(e)
            }
          } else {
            this.$fail('操作失败')
            throw new Error('确认完成失败' + code)
          }
        })
    },

    /**
     * #1185改版后废弃
     * @param inputPrice
     * @param order_price
     * @param coupon_price
     * @param id
     * @returns {V|*}
     */
    changePrice(inputPrice, price, coupon_price, id) {
      let msg
      if (!/(^[1-9]\d*$)/.test(inputPrice) || !inputPrice) {
        msg = '请输入正整数'
      } else if (inputPrice > (price - +coupon_price) * 1.5) {
        msg = '最高为订单原价的150%'
      } else if (inputPrice < (price - +coupon_price) * 0.5) {
        msg = '最低为订单原价的一半'
      }
      if (msg)
        return Promise.resolve({
          data: {
            message: msg
          }
        })
      return this.$http.get(this.mobileSite + 'yuyue/change_price', {
        params: {
          totalPrice: inputPrice,
          id: id
        }
      })
    },

    /**
     * 咨询详情
     */

    /**
     * 去咨询详情
     * @param subOrderId 咨询id
     * @param alowEntry 是否允许进入
     */
    linkToSubDetail(subOrderId, alowEntry) {
      console.log('alowEntry', alowEntry)
      if (alowEntry) {
        this.openWebView({
          url: `${this.staticSite}#/consult-detail?id=${subOrderId}`
        })
      } else {
        return
      }
    },

    /**
     * 咨询订单状态
     * @param {*} type
     * @param {*} step
     * @param {*} useTime
     */
    getConsultOrderState(type, step, sdkChoose) {
      // 状态详见接口文档
      step = Number(step)
      let state // 状态，拼音
      let barData // 进度条数据，数组
      let barActive // 进度条当前进度

      // 如果是取消
      if (step === 5) {
        barData = ['待咨询', '已取消']
        barActive = 2
        state = 'yiquxiao'
      } else {
        barActive = step
        // 面对面
        if (type === 'face' || sdkChoose === 0) {
          barData = ['待咨询', '完成']
          if (step === 1) {
            state = 'daizixun'
          } else {
            state = 'yiwancheng'
          }
        } else {
          barData = ['待咨询', '咨询中', '完成']
          // 判断正在咨询中
          // if (useTime > 0) {
          // } else {
          switch (step) {
            case 1:
              state = 'daizixun'
              break
            case 2:
              state = 'zixunzhong'
              break
            case 3:
              state = 'yiwancheng'
              break
          }
          // }
        }
      }

      return { type, state, barData, barActive, sdkChoose }
    },

    _beforeCall(orderId, isBooking) {
      const loading = this.$loading('加载中')
      return this.$http(`${this.mobileSite}yuyue/makeCall`, {
        params: {
          id: orderId,
          type: isBooking ? 0 : 1
        }
      })
        .then(res => {
          const resData = res.data
          const { code, message } = resData
          loading.close()
          if (code === 0 || code === -1) {
            return resData
          } else if (code === 40007) {
            this.$dialog({
              title: '上次咨询还没有完成，请完成上次咨询再发起咨询',
              theme: '#459cf3',
              buttons: [
                {
                  label: '确认'
                }
              ]
            })
          } else {
            this.$fail(message)
          }
        })
        .catch(() => {
          loading.close()
        })
    },

    _callAction(config) {
      const bridge = this.getBridge() // birdge mixin中定义
      console.log('callAction', config, bridge.call)
      // native & h5接口文档
      bridge.call('callAction', config)
    },

    /**
     * todo:该逻辑已弃用
     * 发起通话
     * @param {String} orderId 订单id
     * @param {Number} seconds 接口返回的剩余秒数
     * @param {String} info 用户信息 roleInfo + yuyueInfo
     * @param {Boolean} isBooking 是不是正式咨询前沟通
     */
    /*
    async madeCall(orderId, info, isBooking = false) {
      if (!this.canMadeCall) {
        this.$dialog({
          maskClose: true,
          title: this.mixinIsApp
            ? '请升级到最新的APP，使用该功能。'
            : '语音沟通老师只支持在APP上进行,请下APP后操作',
          theme: '#459cf3',
          buttons: [
            {
              label: '更新安装APP'
            }
          ]
        }).then(goApp)
        return
      }

      const { data, code } = await this._beforeCall(orderId, isBooking)
      const { id, rest_time, to_user_id, way_type } = data

      if (code === -1 || !rest_time) {
        this.$fail('通话时长已用完')
        return Promise.reject({ message: 'notime' })
      }

      let callType = way_type === 'voice' ? 0 : 1

      if (!to_user_id) {
        this.$fail('呼叫失败，被呼叫对象异常')
        return
      }

      // if (!rest_time) {
      //   this.$fail('呼叫失败，剩余时间已用完')
      //   return Promise.reject({ message: 'notime' })
      // }

      if (!id) {
        this.$fail('呼叫失败，订单不存在')
        return
      }

      let content = ''
      const allBookingTime = 10 * 60
      const toUserName = info.role === 'teacher' ? info.name : info.teacher_name
      if (isBooking) {
        let timeView = this.parseSecToMin(allBookingTime - Number(rest_time))
        content =
          info.role === 'teacher'
            ? `是否发起向${toUserName}发起通话？（该通话只用于与来访者协商时间，总时长10分钟，已使用${timeView}）`
            : `是否向发起${toUserName}老师咨询前沟通，（该通话只用于与老师协商时间，总时长10分钟），已使用${timeView}`
      } else if (rest_time == 90 * 60 && info.role === 'teacher') {
        // 非沟通只有老师可以发起
        content = `是否发起向${toUserName}发起${
          info.waytype
        }？（只在约定咨询时间到了才发起咨询，约定咨询时间请使用下方语音沟通）`
      }
      console.log('content', content)
      if (content) {
        await this.$dialog({
          title: content,
          theme: '#459cf3',
          buttons: [{ label: '取消' }, { label: '确认' }]
        })
      }

      const config = {
        orderId: id,
        // time: Math.ceil(seconds / 60),
        time: rest_time,
        targetUserId: to_user_id,
        callType: isBooking ? 0 : callType, // 如果是咨询前沟通的话，设置成语音
        isBooking: isBooking ? 1 : 0,
        yuyuehao: info.yuyuehao
      }
      console.log('call config', config)
      this._callAction(config)
    },
*/

    /**
     * 确认咨询订单
     * @param {String} orderId 订单id
     */
    async comfirmConsult(orderId) {
      const loading = this.$loading()
      const reqUrl = `${this.mobileSite}yuyue/recordComplete?id=${orderId}`
      return this.$http(reqUrl)
        .then(res => {
          loading.close()
          const { code, message } = res.data
          if (code === 0) {
            this.$success(message)
            this.noticeConsultationPageReLoad()
            return Promise.resolve()
          } else {
            this.$fail(message)
            throw new Error('api code error: ' + code)
          }
        })
        .catch(e => {
          loading.close()
          monitor.stat({
            level: 'error',
            error: 'api',
            url: reqUrl,
            msg: e
          })
        })
    },

    /**
     * s转m:s
     * @param {Number} seconds 秒数
     */
    parseSecToMin(seconds) {
      seconds = Number(seconds)
      const m = Math.floor(seconds / 60)
      const s = seconds % 60
      const mt = m + '分'
      const st = s + '秒'
      return (m > 0 ? mt : '') + st
      // return (m > 0 ? (mt) : '')  + (s > 0 ? (st) : '')
    },

    /**
     * 非灰度，面对面，旧订单打电话
     * @param {Number} 电话号码，无需tel://
     */
    phoneCall(orderId, mobileNum, callback) {
      if (!mobileNum) {
        window.toast('请输入手机号码~')
        return
      }

      let _makeCall = phone => {
        if (this.mixinIsApp || this.platform.isZiXunApp) {
          window.location.href = 'yixinli://open_phone_dial?phone=' + phone
        } else {
          window.location.href = 'tel://' + phone
        }
      }

      this.getPrivitePhoneNumber(orderId, mobileNum)
        .then(res => {
          const { code, message, data } = res.data
          if (code === 0 || code === 40007) {
            //  localstorage保存上次手机号码
            callback && callback()
            localStorage.setItem('ZIXUN_PRIVITE_PHONE_NUMBER', mobileNum)
            if (code === 0) {
              _makeCall(data.secret_phone)
            } else {
              this.$dialog({
                title: message,
                theme: '#0B8BFF',
                buttons: [
                  {
                    label: '取消'
                  },
                  {
                    label: '确认拨打',
                    onClick: () => {
                      _makeCall(data.secret_phone)
                    }
                  }
                ]
              })
            }
          } else {
            callback && callback()
            window.toast(message)
          }
        })
        .catch(e => {
          console.log('error in phoneCall:', e)
        })
    },
    /**
     * 判断手机格式（国内）
     * @param str 手机号码
     * @returns {boolean}
     */
    phoneAvailable(str) {
      return /^[1][0-9][0-9]{9}$/.test(str)
    },

    /**
     * 是否显示拨打电话
     * @param {*} sdkChoose 接口返回的数据
     * @param {*} recordInfo
     * @return {Boolean}
     */
    isShowPhoneCall(sdkChoose, recordInfo, yuyueInfo, roleInfo) {
      // （支付成功 && 待确认 && 用户）
      if (
        (yuyueInfo.pay_status === 'success' &&
          Number(yuyueInfo.status) === 0 &&
          roleInfo.role === 'user') || // 用户侧，待确认隐藏 （陈希）
        Number(yuyueInfo.status) === 4 || // 已完成
        yuyueInfo.pay_status === 'notpay' // 未付款
      ) {
        return false
      }

      if (Number(yuyueInfo.status) === 0) {
        // 接受前
        return sdkChoose === 0
      } else {
        return (
          yuyueInfo.pay_status == 'success' &&
          (sdkChoose === 0 || Array.isArray(recordInfo))
        )
      }
    },

    /**
     * call js bridge noticeConsultationPageReLoad
     */
    noticeConsultationPageReLoad(config = {}) {
      if (this.mixinIsApp || this.platform.isZiXunApp) {
        this.getBridge().call('reloadAllWebView', config)
      }
    },

    /**
     * 获取取消/拒绝原因
     * @param {String} type 类型 cancel/ refuse
     * @return {Promise}
     */
    getReasons(type = 'cancel') {
      const url = `${this.mobileSite}yuyue/reason?reason_type=${type}`
      return this.$http.get(url).then(res => {
        const resData = res.data
        if (Number(resData.code) === 0) {
          return resData.data
        } else {
          return Promise.reject(res)
        }
      })
    },

    getIconCls(type) {
      let cls = ''
      if (['face', '面对面咨询', 'mianjiage'].indexOf(type) > -1) {
        cls = 'mian'
      } else if (['yuyinjiage', '语音咨询', 'voice'].indexOf(type) > -1) {
        cls = 'yuyin'
      } else if (
        ['shipinjiage', '视频咨询', 'vedio', 'video'].indexOf(type) > -1
      ) {
        cls = 'shipin'
      }
      return `icon-${cls}`
    },
    formatTime(date) {
      /* eslint-disable */
      let time = new Date(date.replace(/\-/g, '/')),
        M = time.getMonth() + 1,
        D = time.getDate(),
        H = time.getHours(),
        Min = time.getMinutes()
      H = +H < 10 ? `0${H}` : H
      Min = +Min < 10 ? `0${Min}` : Min
      return `${M}月${D}日 ${H}:${Min}`
    },

    formatTimeValue(date) {
      if (!date) return
      let format = ''
      let nTime = new Date(date)
      format += nTime.getFullYear() + '-'
      format +=
        nTime.getMonth() + 1 < 10
          ? '0' + (nTime.getMonth() + 1)
          : nTime.getMonth() + 1
      format += '-'
      format += nTime.getDate() < 10 ? '0' + nTime.getDate() : nTime.getDate()
      format += 'T'
      format +=
        nTime.getHours() < 10 ? '0' + nTime.getHours() : nTime.getHours()
      format += ':'
      format +=
        nTime.getMinutes() < 10 ? '0' + nTime.getMinutes() : nTime.getMinutes()
      format += ':00'
      return format
    },

    deleteOrder(id) {
      return new Promise((resolve, reject) => {
        const loading = this.$loading()
        this.$http
          .get(`${this.mobileSite}consult/yuyue/delete`, {
            params: {
              id
            }
          })
          .then(res => {
            const resData = res.data
            loading.close()
            if (resData.code === 0) {
              this.isDeleted = true
              resolve(res)
            } else {
              reject(res)
            }
            this.$toast({
              text: resData.message
            })
          })
          .catch(reject.bind(this))
      })
    },
    // 去完善订单信息，teacher_id 老师id, id订单id
    toOrderPrefect({ teacher_id, id, from }) {
      const url =
        this.staticSite +
        `#/consult-order-page-perfect?order_id=${id}&from=${from}`
      this.openWebView({
        url,
        hideNavigationBar: 1
      })
    },

    toChat(id) {
      if (this.platform.isYixinliApp) {
        window.location.href = `yixinli://open_chat?user_id=${id}`
      } else {
        window.location.href = `${
          this.mobileSite
        }/user/message-chat/${id}?hideGoBackBtn=true`
      }
    }
  }
}

export default consultOrder



// WEBPACK FOOTER //
// ./src/mixins/consultOrder.js